<h6 class="bxt-table-title">{{ title }} ({{ page.totalElements }})</h6>

<bx-table-header
    [showCreateNew]="false"
    (searchEvent)="setSearch($event)"
    [searchable]="true"
    [showSettingsActions]="true"
    (settingsActionEvent)="resolveSettingsAction($event)"
    [moreActions]="moreActions"
    (moreActionEvent)="resolveAction($event)">
    <app-bx-dropdown-generic settings #dropdown [buttonLabel]="'Settings'" [placement]="'right'" [insideClick]="true">
        <app-bx-dropdown-options [groups]="simpleItems" [type]="'simple'" (select)="resolveSettingsAction($event); dropdown.close()">
        </app-bx-dropdown-options>
    </app-bx-dropdown-generic>
</bx-table-header>

<div class="col-xs-12 text-center empty-table" *ngIf="rows?.length === 0 && !isLoading">
    <h4 class="margin-top-30 margin-bottom-30">You don't have any orders here yet.</h4>
    <br />
</div>

<div class="table-wrapper" #tableWrapper>
    <ngx-datatable
        #myTable
        class="material bxt-table"
        [rowHeight]="40"
        [rows]="rows"
        [columnMode]="tableColumnMode"
        [headerHeight]="50"
        [loadingIndicator]="isLoading"
        [footerHeight]="50"
        [externalPaging]="true"
        [count]="page.totalElements"
        [offset]="page.pageNumber"
        [limit]="page.size"
        (page)="setPage($event)"
        [externalSorting]="true"
        (sort)="onSort($event)"
        [scrollbarV]="true"
        [scrollbarH]="layoutService.isMobile()"
        [virtualization]="false"
        [sorts]="[{ prop: sortField, dir: 'asc' }]"
        *ngIf="rows?.length"
        (resize)="onResize()">
        <!-- columns  -->
        <ngx-datatable-column
            name="Order #"
            prop="OrderNumber"
            [cellClass]="'show-pipe'"
            [headerClass]="'show-pipe'"
            [flexGrow]="4"
            [width]="ordersWidths.OrderNumber">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                    *ngIf="permissionService.isAvailable('jobs.maintain-purchase-orders.view-purchase-orders'); else disabledOrderNo"
                    class="bxt-row-action"
                    title="{{ row.OrderNumber }}"
                    (click)="viewOrder(row)">
                    <span *ngIf="row.OrderNumber === 0; else hasNumber">(new)</span></a
                >
                <ng-template #disabledOrderNo>
                    <span *ngIf="row.OrderNumber === 0; else hasNumber">(new)</span>
                </ng-template>
                <ng-template #hasNumber>{{ row.OrderNumber }}</ng-template>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Description" prop="Description" [flexGrow]="6" [width]="ordersWidths.Description">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                    *ngIf="permissionService.isAvailable('jobs.maintain-purchase-orders.view-purchase-orders'); else disabledDesc"
                    class="bxt-row-action"
                    title="{{ row.Description }}"
                    (click)="viewOrder(row)"
                    [title]="row.Description">
                    {{ row.Description }}</a
                >
                <ng-template #disabledDesc
                    ><span [title]="row.Description">{{ row.Description }}</span></ng-template
                >
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Job" prop="Job/Description" [flexGrow]="7" [width]="ordersWidths['Job/Description']">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                    *ngIf="permissionService.isAvailable('jobs.maintain-jobs.view-jobs'); else disabledJobDesc"
                    class="bxt-row-action"
                    title="{{ row.Job.FullDescription }}"
                    [routerLink]="['/jobs', 'list', row.ID_Reference]">
                    {{ row.Job.FullDescription }}</a
                >
                <ng-template #disabledJobDesc>{{ row.Job.FullDescription }}</ng-template>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
            name="Supplier #"
            prop="SupplierInvoiceRef"
            [flexGrow]="5"
            [width]="ordersWidths.SupplierInvoiceRef"></ngx-datatable-column>
        <ngx-datatable-column
            name="Supplier/Assigned"
            prop="SupplierDescription"
            [sortable]="false"
            [flexGrow]="5"
            [width]="ordersWidths.SupplierDescription"></ngx-datatable-column>
        <ngx-datatable-column name="Created" prop="OrderDate" [flexGrow]="5" [width]="ordersWidths.OrderDate">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.OrderDate | date }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Required" prop="RequiredByDateLocal" [flexGrow]="5" [width]="ordersWidths.RequiredByDateLocal">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.RequiredByDateLocal | date }}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
            name="Total (Ex)"
            prop="OrderTotalExTax"
            [flexGrow]="5"
            [cellClass]="'right-align'"
            [width]="ordersWidths.OrderTotalExTax">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span [title]="row.OrderTotalExTax | bxCurrency">{{ row.OrderTotalExTax | bxCurrency }}</span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Type" prop="OrderType" [flexGrow]="4" [width]="ordersWidths.OrderType">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span *ngIf="row.OrderType === 'purchase'; else workOrder" title="Purchase Order">PO</span>
                <ng-template #workOrder><span title="Work Order">WO</span></ng-template>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Status" prop="OrderStatus" [flexGrow]="5" [width]="ordersWidths.OrderStatus">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                    class="status-pill"
                    [ngClass]="{
                        new: row.OrderStatus === 'Unsent',
                        orange: row.OrderStatus === 'Sent',
                        blue: row.OrderStatus === 'PartReceived',
                        green: row.OrderStatus === 'Received' || row.OrderStatus === 'Completed',
                        lost: row.OrderStatus === 'Cancelled',
                    }"
                    >{{ row.OrderStatus }}</span
                >
                <span class="sync-status-tick" *ngIf="row.HasInvoiceAccSyncData">
                    <i class="icon-ic-tick-s1" title="Synced"></i>
                </span>
            </ng-template>
        </ngx-datatable-column>

        <!-- Call to action list-->
        <ngx-datatable-column
            [width]="130"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [cellClass]="'right-align'"
            [headerClass]="'disabled'">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <button
                    type="button"
                    class="btn btn-sm btn-info btn-default--narrow margin-right-2"
                    *ngIf="
                        row.OrderType === 'purchase' &&
                        permissionService.isAvailable('jobs.maintain-purchase-orders.receipt-purchase-order') &&
                        (row.OrderStatus === 'Sent' || row.OrderStatus === 'PartReceived')
                    "
                    (click)="addOrderInvoice(row)"
                    title="Add Invoice/Receipt">
                    <i class="ti-receipt"></i>
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-default btn-default--narrow margin-right-2"
                    (click)="printOrder(row)"
                    title="Print">
                    <i class="ti-printer"></i>
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-default btn-default--narrow margin-right-1"
                    *ngIf="isOrderEmailVisible"
                    (click)="emailOrder(row)"
                    title="Email">
                    <i class="ti-email"></i>
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-danger btn-default--narrow margin-right-1"
                    [disabled]="row.OrderStatus !== 'Unsent'"
                    title="Delete"
                    (click)="deleteOrder($event, row)">
                    <i class="ti-trash"></i>
                </button>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-selectedCount="selectedCount"
                let-curPage="curPage"
                let-offset="offset"
                let-isVisible="isVisible">
                <app-table-footer-paging *ngIf="rowCount > 10" [size]="page.size" (pageLimitChange)="pageLimit($event)">
                </app-table-footer-paging>

                <datatable-pager
                    [pagerLeftArrowIcon]="'datatable-icon-left'"
                    [pagerRightArrowIcon]="'datatable-icon-right'"
                    [pagerPreviousIcon]="'datatable-icon-prev'"
                    [pagerNextIcon]="'datatable-icon-skip'"
                    [page]="curPage"
                    [size]="pageSize"
                    [count]="rowCount"
                    [hidden]="!(rowCount / pageSize > 1)"
                    (change)="table.onFooterPage($event)">
                </datatable-pager>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>
